import React from "react"
import Image from "gatsby-image"
import { Link } from "gatsby"
import { graphql, useStaticQuery } from "gatsby"
import SocialLinks from "../constants/socialLinks"

const query = graphql`
{
  file(relativePath: {eq: "image.png"}) {
    childImageSharp {
      fluid {
        ...GatsbyImageSharpFluid
      }
    }
  }
}
`
const Hero = () => {
  const data = useStaticQuery(query);
  const {file: {
      childImageSharp: {
           fluid
    }}}  = data;
  return <header className='hero' >
    <div className='section-center hero-center'>
      <article className='hero-info'>
        <div>
        <div className='underline'></div>
          <h1> I'm Aman </h1>
          <h4 className='hero-details'>Software Developer at <strong>UKG Ultimate Kronos Group</strong></h4>
        </div>
        <Link to='/contact' className='btn'>
        Contact Me
      </Link>
      <SocialLinks/>
      </article>
      
      <Image fluid={fluid} className='hero-img'/>
      

      </div>
  </header>
}

export default Hero
